/**
 * Trunnion AI - useCommandPalette Hook
 * Convenience hook for accessing the Command Palette context.
 *
 * Usage:
 *   const { open, close, isOpen, registerCommand, unregisterCommand, commands } = useCommandPalette();
 */

import { useContext } from 'react';
import {
  CommandPaletteContext,
  type CommandPaletteContextValue,
} from '@/components/command-palette/CommandPaletteProvider';

export function useCommandPalette(): CommandPaletteContextValue {
  const ctx = useContext(CommandPaletteContext);

  if (ctx === undefined) {
    throw new Error('useCommandPalette must be used within a CommandPaletteProvider');
  }

  return ctx;
}
